import {
  greaterThanOrEqualTime,
  parseTime,
} from 'src/app/component/shared/utils';
import { TimetableStop, TimetableTrip } from '../time-table-types';

/**
 *
 * @param tripData timetable data
 * returns
 */
export const validateTripTimetable = (
  tripStops: TimetableStop[]
): { valid: boolean; message: string; stops?: TimetableStop[] } => {
  console.log('stops: ', tripStops);
  let issueStops = [];
  let message = '';
  const isScheduleDecreasing = tripStops.some((currStop, index) => {
    if (index < 1) return false;
    const prevStop = tripStops[index - 1];
    const { schArrTime: currSchArrTime } = currStop;
    const { schArrTime: prevSchArrTime } = prevStop;
    const time1 = parseTime(prevSchArrTime);
    const time2 = parseTime(currSchArrTime);
    console.log({
      1: { 1: prevStop.stopSequence, time1, prevSchArrTime },
      2: { 2: currStop.stopSequence, time2, currSchArrTime },
    });
    const isIncreasingTime = greaterThanOrEqualTime(time2, time1);
    if (!isIncreasingTime) {
      message = `Scheduled time for stop (${prevStop.stopSequence}) [${prevSchArrTime}] is later 
      than the next stop (${currStop.stopSequence}) [${currSchArrTime}]`;
      issueStops = [prevStop, currStop];
      return true;
    }
    return false;
  });
  if (isScheduleDecreasing) return { message, valid: false, stops: issueStops };
  return { valid: true, message: '' };
};
